const { useState, useCallback, useEffect } = require('react')
import { CircularProgress, Grid, Paper, Typography } from '@material-ui/core'
import MaterialTable from 'material-table'
import { forwardRef } from 'react'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import SearchIcon from '@material-ui/icons/Search'
import ClearIcon from '@material-ui/icons/Clear'
import SendIcon from '@material-ui/icons/Send'
import DoneIcon from '@material-ui/icons/Done'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import FirstPageIcon from '@material-ui/icons/FirstPage'
import LastPageIcon from '@material-ui/icons/LastPage'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import useStyles from './styles'
import { useSolicitacaoExameService } from 'hooks/useSolicitacaoExameService'
import useRouter from 'utils/useRouter'
import { Espelho } from 'components/Espelho'
import { SelectSetor } from 'components/SelectSetor'

export const TabelaSolicitacao = (props) => {
  const { situacao, idSetor } = props
  moment.locale('pt-br', localization)
  const classes = useStyles()
  const router = useRouter()
  const solicitacaoExameService = useSolicitacaoExameService()
  const [protocolos, setProtocolos] = useState([])
  const [processando, setProcessando] = useState(false)
  const [openConcluir, setOpenConcluir] = useState(false)
  const [processandoConcluir, setProcessandoConcluir] = useState(false)
  const [despachoSelecionado, setDespachoSelecionado] = useState(null)
  const [openDespachar, setOpenDespachar] = useState(false)
  const [setorDespacho, setSetoDespacho] = useState(null)
  const [processandoDespachar, setProcessandoDespachar] = useState(false)
  const [setoresDespacho, setSetoresDespachos] = useState([])

  const fetchDespachos = useCallback(async () => {
    setProcessando(true)
    let response = []
    const funcoesPorSituacao = {
      ABERTO: solicitacaoExameService.listarDespachosSolicitacoesAbertos,
      CONCLUIDO: solicitacaoExameService.listarDespachosSolicitacoesConcluidos,
    }

    const funcaoExecucao = funcoesPorSituacao[situacao]

    if (funcaoExecucao) {
      response = await funcaoExecucao(idSetor)
    }

    setProtocolos(response)

    setProcessando(false)
  }, [situacao, idSetor])

  const handleClickConcluir = useCallback((id) => {
    setDespachoSelecionado(id)
    setOpenConcluir(true)
  }, [])

  const handleClickDespachar = useCallback((id) => {
    setDespachoSelecionado(id)
    setOpenDespachar(true)
  })

  const concluir = useCallback(async () => {
    await solicitacaoExameService.concluirDespacho(despachoSelecionado)
    fetchDespachos()
    setOpenConcluir(false)
  }, [fetchDespachos, despachoSelecionado])

  const despachar = useCallback(async () => {
    await solicitacaoExameService.redespachar(
      despachoSelecionado,
      setoresDespacho.map((setor) => setor.id)
    )
    fetchDespachos()
    setOpenDespachar(false)
  }, [fetchDespachos, despachoSelecionado, setoresDespacho])

  useEffect(() => {
    fetchDespachos()
  }, [fetchDespachos])

  return processando ? (
    <div className={classes.carregando}>
      <CircularProgress disableShrink />
    </div>
  ) : (
    <>
      <Grid container xs={12} sm={12} md={12}>
        <Grid item xs={12} sm={12} md={12} sty>
          <MaterialTable
            components={{ Container: (props) => <Paper {...props} elevation={0} /> }}
            localization={{
              pagination: {
                labelDisplayedRows: '{from}-{to} de {count}',
                labelRowsSelect: 'linhas',
                nextTooltip: 'Página seguinte',
                previousTooltip: 'Página anterior',
                lastTooltip: 'Última página',
                firstTooltip: 'Primeira página',
              },
              toolbar: {
                nRowsSelected: '{0} linha(s) selecionadas',
                searchPlaceholder: 'Buscar',
              },
              header: {
                actions: 'Ações',
              },
              body: {
                emptyDataSourceMessage: 'Nada para mostrar',
                filterRow: {
                  filterTooltip: 'Filtro',
                },
              },
            }}
            columns={[
              {
                title: 'Número da solicitação',
                render: (rowData) => rowData.solicitacao.identificador,
              },
              {
                title: 'Setor responsável',
                render: (rowData) => (rowData.solicitacao ? `${rowData.solicitacao.setReq.nome.toUpperCase()} / ${rowData.solicitacao.setReq.divisao.sigla.toUpperCase()} / ${rowData.solicitacao.setReq.divisao.regional.sigla.toUpperCase()}` : '-'),
              },
              {
                title: 'Data',
                render: (rowData) => moment(rowData.updatedAt).format('LLLL'),
              },
            ]}
            onRowClick={(event, rowData, togglePanel) => {
              router.history.push(`/solicitacaoexame/fichasolicitacaoexame/detalhar/${rowData.id_solicitacao_exame}`)
            }}
            title=""
            data={protocolos}
            actions={
              situacao === 'ABERTO'
                ? [
                    () => ({
                      icon: () => <SendIcon fontSize="small" />,
                      tooltip: 'Despachar',
                      onClick: (event, rowData) => handleClickDespachar(rowData.id),
                    }),
                    {
                      icon: () => <DoneIcon fontSize="small" />,
                      tooltip: 'Concluir no setor',
                      onClick: (event, rowData) => handleClickConcluir(rowData.id),
                    },
                  ]
                : []
            }
            options={{
              actionsColumnIndex: -1,
              search: true,
              pageSize: 10,
              searchFieldStyle: {
                flexGrow: 1,
                height: 42,
                // padding: theme.spacing(0, 2),
                display: 'flex',
                alignItems: 'center',
              },
              headerStyle: {
                backgroundColor: '#f4f6f8',
              },
            }}
            style={{
              padding: '0',
              margin: '0',
              fontSize: '13px',
              textAlign: 'left',
              fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
              fontWeight: '400',
              lineHeight: '21px',
              borderBottom: '1px solid #eeeeee',
              letterSpacing: '-0.05px',
              verticalAlign: 'inherit',
            }}
            icons={{
              SortArrow: forwardRef((propsSortArrow, ref) => <ArrowDownwardIcon {...propsSortArrow} ref={ref} />),
              Search: forwardRef((propsSearch, ref) => <SearchIcon {...propsSearch} ref={ref} />),
              ResetSearch: forwardRef((propsResetSearch, ref) => <ClearIcon {...propsResetSearch} ref={ref} />),
              NextPage: forwardRef((propsNextPage, ref) => <NavigateNextIcon {...propsNextPage} ref={ref} />),
              DetailPanel: forwardRef((propsNextPage, ref) => <NavigateNextIcon {...propsNextPage} ref={ref} />),
              PreviousPage: forwardRef((propsPreviousPage, ref) => <NavigateBeforeIcon {...propsPreviousPage} ref={ref} />),
              FirstPage: forwardRef((propsFirstPage, ref) => <FirstPageIcon {...propsFirstPage} ref={ref} />),
              LastPage: forwardRef((propsLastPage, ref) => <LastPageIcon {...propsLastPage} ref={ref} />),
            }}
          />
        </Grid>
      </Grid>
      <Espelho aberto={openConcluir} setAberto={setOpenConcluir} handleConfirmar={concluir} processando={processandoConcluir} titulo="Confirmação de conclusão">
        <Typography>Deseja concluir esse despacho no setor? </Typography>
      </Espelho>
      <Espelho aberto={openDespachar} setAberto={setOpenDespachar} disabled={setoresDespacho?.length === 0} handleConfirmar={despachar} processando={processandoDespachar} titulo="Confirmação de despacho">
        <Grid item md={12} lg={12} sm={12} xs={12}>
          <SelectSetor setoresExternos={setoresDespacho} setSetoresExternos={setSetoresDespachos} label="Pesquise o setor de despacho" />
        </Grid>
      </Espelho>
    </>
  )
}
